import React from 'react'
import {
    CheckOutlined,
    DoubleLeftOutlined,
    DeleteOutlined,
    SyncOutlined,
} from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { ChangePriorityWithNext_Reserve_Api, ConfirmFilesByAdmin_Reserve_Api, ConfirmPaymentByAdmin_Reserve_Api, CancelByAdmin_Reserve_Api, AcceptByReception_Reserve_Api, ConfirmFoodAndParkingPaymentByAdmin_Reserve_Api, CancelFoodAndParkingByAdmin_Reserve_Api } from '../../API/ReserveApi';
// =================================================================
export const AdminBarComponent = ({
    setLoading,
    showMessage,
    reserve,
    setVersion,
    version,
    foodMode = false,
    reserveMode = true,
    receptionMode = false,
}) => {
    // =================================================================
    const ConfirmReserveFiels = async () => {
        setLoading(true);
        try {
            const data = await ConfirmFilesByAdmin_Reserve_Api(reserve.id);
            setLoading(false)
            if (data.messageStatus == "Successful") {
                setVersion(version + 1);
                showMessage(data.message, "Successful");
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const ConfirmReservePayment = async () => {
        setLoading(true);
        try {
            const data = await ConfirmPaymentByAdmin_Reserve_Api(reserve.id);
            setLoading(false)
            if (data.messageStatus == "Successful") {
                setVersion(version + 1);
                showMessage(data.message, "Successful");
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const ConfirmFoodAndParkingPayment = async () => {
        setLoading(true);
        try {
            const data = await ConfirmFoodAndParkingPaymentByAdmin_Reserve_Api(reserve.id);
            setLoading(false)
            if (data.messageStatus == "Successful") {
                setVersion(version + 1);
                showMessage(data.message, "Successful");
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const ChangePriorityWithNext = async () => {
        setLoading(true);
        try {
            const data = await ChangePriorityWithNext_Reserve_Api(reserve.id);
            setLoading(false)
            if (data.messageStatus == "Successful") {
                setVersion(version + 1);
                showMessage(data.message, "Successful");
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const AcceptByReception = async () => {
        setLoading(true);
        try {
            const data = await AcceptByReception_Reserve_Api(reserve.id);
            setLoading(false)
            if (data.messageStatus == "Successful") {
                setVersion(version + 1);
                showMessage(data.message, "Successful");
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const CancelReserve = async () => {
        setLoading(true);
        try {
            const data = await CancelByAdmin_Reserve_Api(reserve.id);
            setLoading(false)
            if (data.messageStatus == "Successful") {
                setVersion(version + 1);
                showMessage(data.message, "Successful");
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const CancelFoodAndParking = async () => {
        setLoading(true);
        try {
            const data = await CancelFoodAndParkingByAdmin_Reserve_Api(reserve.id);
            setLoading(false)
            if (data.messageStatus == "Successful") {
                setVersion(version + 1);
                showMessage(data.message, "Successful");
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    return (
        <div className='adminbar no-print'>

            {
                reserve.reserveStatus == "FileUploadWaiting" && reserveMode ?
                    <Button
                        className='btn-success'
                        style={{ marginLeft: '5px' }}
                        onClick={

                            () => {
                                Modal.confirm({
                                    title: 'آیا از تایید مدارک اطمینان دارید؟',
                                    onOk: () => { ConfirmReserveFiels() },
                                    footer: (_, { OkBtn, CancelBtn }) => (
                                        <>
                                            <CancelBtn />
                                            <OkBtn />
                                        </>
                                    ),
                                });
                            }
                        }
                    >
                        تایید مدارک
                        <CheckOutlined />
                    </Button> : <></>
            }

            {
                (reserve.reserveStatus == "PayWaiting" || reserve.reserveStatus == "Payed") && reserveMode ?
                    <Button
                        className='btn-success'
                        style={{ marginLeft: '5px' }}
                        onClick={

                            () => {
                                Modal.confirm({
                                    title: 'آیا از تایید پرداخت اطمینان دارید؟',
                                    onOk: () => { ConfirmReservePayment() },
                                    footer: (_, { OkBtn, CancelBtn }) => (
                                        <>
                                            <CancelBtn />
                                            <OkBtn />
                                        </>
                                    ),
                                });
                            }
                        }
                    >
                        تایید پرداخت
                        <CheckOutlined />
                    </Button> : <></>
            }

            {reserve.reserveStatus == "Completed" && receptionMode ?
                <Button
                    className='btn-primary'
                    style={{ marginLeft: '5px' }}
                    onClick={

                        () => {
                            Modal.confirm({
                                title: 'آیا از ثبت پذیرش اطمینان دارید؟',
                                onOk: () => { AcceptByReception() },
                                footer: (_, { OkBtn, CancelBtn }) => (
                                    <>
                                        <CancelBtn />
                                        <OkBtn />
                                    </>
                                ),
                            });
                        }
                    }
                >
                    پذیرش
                    <CheckOutlined />
                </Button> : <></>
            }

            {(reserve.reserveStatus == "WonInLottery" ||
                reserve.reserveStatus == "FileUploadWaiting" ||
                reserve.reserveStatus == "PayWaiting" ||
                reserve.reserveStatus == "Payed") && reserveMode ?
                <Button
                    className='btn-warning'
                    style={{ marginLeft: '5px' }}
                    onClick={

                        () => {
                            Modal.confirm({
                                title: 'آیا این رزرو با اولویت بعدی جایگزین شود؟',
                                onOk: () => { ChangePriorityWithNext() },
                                footer: (_, { OkBtn, CancelBtn }) => (
                                    <>
                                        <CancelBtn />
                                        <OkBtn />
                                    </>
                                ),
                            });
                        }
                    }
                >
                    جایگزین با نفر بعدی
                    <SyncOutlined />
                </Button> : <></>
            }

            {(reserve.reserveStatus == "WonInLottery" ||
                reserve.reserveStatus == "FileUploadWaiting" ||
                reserve.reserveStatus == "PayWaiting" ||
                reserve.reserveStatus == "Payed") && reserveMode ?
                <Button
                    className='btn-danger'
                    style={{ marginLeft: '5px' }}
                    onClick={

                        () => {
                            Modal.confirm({
                                title: 'آیا از کنسل شدن رزرو اطمینان دارید؟',
                                onOk: () => { CancelReserve() },
                                footer: (_, { OkBtn, CancelBtn }) => (
                                    <>
                                        <CancelBtn />
                                        <OkBtn />
                                    </>
                                ),
                            });
                        }
                    }
                >
                    کنسل کردن رزرو
                    <DeleteOutlined />
                </Button> : <></>
            }

            {(reserve.foodAndParkingStatus == "Payed") && foodMode ?
                <Button
                    className='btn-success'
                    style={{ marginLeft: '5px' }}
                    onClick={

                        () => {
                            Modal.confirm({
                                title: 'آیا از تایید پرداخت اطمینان دارید؟',
                                onOk: () => { ConfirmFoodAndParkingPayment() },
                                footer: (_, { OkBtn, CancelBtn }) => (
                                    <>
                                        <CancelBtn />
                                        <OkBtn />
                                    </>
                                ),
                            });
                        }
                    }
                >
                    تایید پرداخت غذا و پارکینگ
                    <CheckOutlined />
                </Button> : <></>
            }

            {(reserve.foodAndParkingStatus == "Payed" || reserve.foodAndParkingStatus == "Completed") && foodMode  ?
                <Button
                    className='btn-danger'
                    style={{ marginLeft: '5px' }}
                    onClick={

                        () => {
                            Modal.confirm({
                                title: 'آیا از کنسل شدن رزرو غذا و پارکینگ اطمینان دارید؟',
                                onOk: () => { CancelFoodAndParking() },
                                footer: (_, { OkBtn, CancelBtn }) => (
                                    <>
                                        <CancelBtn />
                                        <OkBtn />
                                    </>
                                ),
                            });
                        }
                    }
                >
                    عدم تایید غذا و پارکینگ
                    <DeleteOutlined />
                </Button> : <></>
            }
        </div>
    )
}
